module.exports = __webpack_public_path__ + "static/img/rank_82.61c9bfa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_82.png
// module id = eGyn
// module chunks = 1